import React, { useEffect, useRef } from "react";

import Tooltip from "@mui/material/Tooltip";

import { ReactComponent as IconDetalhes } from "../../build/images/attendanceIcons/icon-detalhes.svg";
import { ReactComponent as IconPesquisa } from "../../build/images/attendanceIcons/icon-pesquisa.svg";
import { ReactComponent as IconCampanha } from "../../build/images/attendanceIcons/icon-campanha.svg";
import { ReactComponent as IconAjuda } from "../../build/images/attendanceIcons/icon-ajuda.svg";
import { ReactComponent as IconClose } from "../../build/images/attendanceIcons/close-side-info.svg";

import "./side-content-attendance.css";
import { useDispatch, useSelector } from "react-redux";
import { closeSideContent } from "../../actions/closeSideContent";
import { sideContentAttendanceSelected } from "../../actions/sideContentAttendanceSelected";
//import { connection_platform } from "../../services/api";

export default function SideContentAttendance({
  children,
  hasPesquisa = true,
}) {
  const sideContentSelected = useSelector(
    (state) => state.sideContentAttendanceSelected
  );
  const ingFaqConditions = useSelector((state) => state.ingFaqConditions);
  const dispatch = useDispatch();

  console.log("ingFaqConditions", ingFaqConditions);

  return (
    <div className="side-content-attendance">
      <ul className="side-content-attendance__header">
        <li
          className={`side-content-attendance__header__item ${
            sideContentSelected === "detalhes" ? "active" : ""
          }`}
        >
          <Tooltip
            title="Detalhes"
            placement="top"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  padding: "8px 16px",
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "19.6px",
                },
              },
            }}
          >
            <button
              className="btn-fill-stroke"
              onClick={() =>
                dispatch(sideContentAttendanceSelected("detalhes"))
              }
            >
              <IconDetalhes />
            </button>
          </Tooltip>
        </li>
        {hasPesquisa && (
          <li
            className={`side-content-attendance__header__item ${
              sideContentSelected === "pesquisa" ? "active" : ""
            }`}
          >
            <Tooltip
              title="Pesquisa"
              placement="top"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    padding: "8px 16px",
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "19.6px",
                  },
                },
              }}
            >
              <button
                className="btn-fill-stroke"
                onClick={() =>
                  dispatch(sideContentAttendanceSelected("pesquisa"))
                }
              >
                <IconPesquisa />
              </button>
            </Tooltip>
          </li>
        )}
        {ingFaqConditions.isCampaignActive && (
          <li
            className={`side-content-attendance__header__item ${
              sideContentSelected === "campanhas" ? "active" : ""
            }`}
          >
            <Tooltip
              title="Campanhas"
              placement="top"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    padding: "8px 16px",
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "19.6px",
                  },
                },
              }}
            >
              <button
                className="btn-fill"
                onClick={() =>
                  dispatch(sideContentAttendanceSelected("campanhas"))
                }
              >
                <IconCampanha />
              </button>
            </Tooltip>
          </li>
        )}
        {ingFaqConditions.isHelpActive && (
          <li
            className={`side-content-attendance__header__item ${
              sideContentSelected === "ajuda" ? "active" : ""
            }`}
          >
            <Tooltip
              title="Ajuda"
              placement="top"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    padding: "8px 16px",
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "19.6px",
                  },
                },
              }}
            >
              <button
                className="btn-fill"
                onClick={() => dispatch(sideContentAttendanceSelected("ajuda"))}
              >
                <IconAjuda />
              </button>
            </Tooltip>
          </li>
        )}
        <li className="side-content-attendance__header__close-icon">
          <Tooltip
            title="Fechar"
            placement="top"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  padding: "8px 16px",
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "19.6px",
                },
              },
            }}
          >
            <button
              onClick={() => {
                dispatch(closeSideContent());
              }}
            >
              <IconClose />
            </button>
          </Tooltip>
        </li>
      </ul>
      <div className="side-content-attendance__content">{children}</div>
    </div>
  );
}
